import * as React from 'react';
import { connect } from 'react-redux';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import PageHeading from 'components/page/page-heading/PageHeading';

import { navigate } from 'libs/router';

import { __t, applyTranslations } from 'utils/language';

import './ccm-campaign-create-header.scss';

applyTranslations(require('./ccm-campaign-create-header.i18n.json'));

type OwnProps = {
  brandProfileId: number
};

type StateProps = {
  isCcmCreatorlessEnabled: boolean
}

type Props = OwnProps & StateProps;

const CcmCampaignCreateHeader = ({
  brandProfileId,
  isCcmCreatorlessEnabled
}: Props): JSX.Element => (
  <div className="ccm-campaign-create-header">
    <div className="ccm-campaign-create-header__page-heading-container">
      <PageHeading
        heading={__t('ccm_campaign_create_header.page_header')}
        weight="bold"
        color="light"
      />
    </div>
    {isCcmCreatorlessEnabled ? (
      <div
        className="ccm-campaign-create-header__back-link"
        onClick={() => navigate.to(`/brand/profiles/${brandProfileId}/campaigns/ccm/select-campaign-type`)}
      >
        <SVGDynamicIcon
          name="arrow-left-custom-bg"
          width={16}
          height={8}
          customColor="grey-light"
        />
        <span className="ccm-campaign-create-header__back-link-text">
          {__t('ccm_campaign_create_header.header_step2_back_text')}
        </span>
      </div>
    ) : null}
  </div>
);

const mapStateToProps = ({ runtimeConfig }): StateProps => ({
  isCcmCreatorlessEnabled: Boolean(runtimeConfig.config.isCcmEnabled)
    && Boolean(runtimeConfig.config.isCcmCreatorlessEnabled)
});

export default connect(mapStateToProps)(CcmCampaignCreateHeader);
